export class FileUpload {
    fileName: string;
}
